import { observer } from 'mobx-react-lite'
import { Icon } from '@/components/Icon'
import { CardContent } from '@/components/Card'
import { ContentError } from '@/components/ContentError'
import { ContentLoading } from '@/components/ContentLoading'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import {
  EventsCard,
  EventsCardList,
  EventsFilters,
} from '@/features/jobs/details/components/EventsCard'
import { JobEventContainer } from '@/features/jobs/details/components/EventsCard/JobEvent/JobEventContainer'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'

export interface EventsCardContainerProps {
  vm: JobDetailsViewModel
}

export const EventsCardContainer = observer(function EventsCardContainer({
  vm,
}: EventsCardContainerProps) {
  const renderEvents = () => (
    <EventsCardList>
      {vm.detailsVm.filteredEvents.map((event) => (
        <JobEventContainer event={event} key={event.id} />
      ))}

      <InfiniteScrollLoaderContainer
        compact
        scrollProvider={vm.detailsVm.jobEventsScrollProvider}
      />
    </EventsCardList>
  )

  return (
    <EventsCard
      filters={
        <EventsFilters
          eventFilter={vm.detailsVm.eventFilter}
          onEventFilterChange={vm.detailsVm.setEventFilter}
          icon={<Icon name="dropdown" size={20} />}
        />
      }
    >
      {vm.detailsVm.jobEventsScrollProvider.fetch.match({
        pending: () =>
          vm.detailsVm.isRevalidatingEvents ? (
            renderEvents()
          ) : (
            <CardContent>
              <ContentLoading size="section" />
            </CardContent>
          ),
        rejected: (err) => (
          <CardContent>
            <ContentError
              size="section"
              title="An error occurred while loading events."
              error={err}
            />
          </CardContent>
        ),
        resolved: renderEvents,
      })}
    </EventsCard>
  )
})
